export default {
  error: state => state.error,
  formLoading: state => state.formLoading,
  success: state => state.success,
  loading: state => state.loading,
  syndicate: state => state.syndicate,
  syndicates: state => state.syndicates,
  syndicateLink: state => state.syndicateLink,
  // eslint-disable-next-line
  syndicateAdministrators: state => (syndicateID) => {
    const syndicate = state.syndicates.find(s => s.syndicateID === syndicateID);
    return syndicate.administrators;
  },
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/getters.js